import React, { useState, useEffect } from 'react';
import { Table, Button, Row, Col, message } from 'antd';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { connect } from 'react-redux';
import { addRole, resetAddRole, fetchRole } from 'appRedux/actions/Role';
import Widget from 'components/Widget';
import convertData from 'firebase/utils/convertData';
import { EditableCell, EditableFormRow } from './EditableCell';
import Columns from './Columns';

const InsertUser = ({ addRole, resetAddRole, updating, payload, currentUser, fetchRole, roleList, loadingRole }) => {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [isReset, setIsReset] = useState(false);
  const [dataSource, setDataSource] = useState([
    {
      email: '',
      key: 0,
      line_manager: '',
      role: '',
    }
  ]);
  const [count, setCount] = useState(1);

  const isNotAllowSubmit = disableSubmit || dataSource.length === 0;
  const roles = isEmpty(roleList) ? [] : convertData(roleList);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const handleDelete = key => {
    const data = [...dataSource];
    setDataSource(data.filter(item => item.key !== key));
  };

  const columns = Columns(handleDelete).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError,
        loadingRole,
        roles,
        isReset,
      }),
    };
  });

  const handleAdd = (e) => {
    e.preventDefault();
    const newData = {
      key: count,
      email: '',
      line_manager: '',
      role: '',
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleUpdateRow = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const handleError = (isDisabled) => {
    setDisableSubmit(isDisabled);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setDisableSubmit(true);
    setCount(1);
    setIsReset(true);
    setDataSource([]);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const validData = dataSource.filter(item => item.email);
    if (validData.length === 0) {
      message.error({ content: 'Dữ liệu bạn nhập chưa đầy đủ thông tin', key: 'updatable', duration: 2 });
      return;
    }

    const params = validData.map((item, i) => ({
      index: i + 1,
      email: item.email,
      role: item.role || 'member',
      line_manager: item.line_manager,
      created_by: currentUser,
      updated_by: currentUser,
      created_at: moment().unix(),
      updated_at: moment().unix(),
    }));

    addRole({ params });
  };

  useEffect(() => {
    fetchRole({ filter: { role: 'line-manager' } })
  },[fetchRole]);

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 2 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 2 });
      }
      resetAddRole();
    }
  }, [payload.code, payload.message, resetAddRole]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Add user</h2>}
          >
            <Button icon='plus' onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
              Add user
            </Button>
            <Table
              className='gx-table-no-bordered'
              pagination={false}
              bordered={false}
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={dataSource}
              columns={columns}
            />
            <div className='save-segment'>
              <Button loading={updating} disabled={isNotAllowSubmit} onClick={handleSave} icon='vertical-align-bottom' size='large' type="primary">
                Save
              </Button>
              <Button disabled={updating} onClick={handleReset} icon='undo' size='large'>
                Reset
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ role, auth }) => {
  const { updating, payload, data: roleList, loading: loadingRole } = role;
  const { currentUser } = auth;
  return { updating, payload, currentUser, roleList, loadingRole };
};

export default connect(
  mapStateToProps,
  { addRole, resetAddRole, fetchRole }
)(InsertUser);
